import React from 'react';
import Custom from './Custom';
import TitleMeta from './TitleMeta';
import FeaturedSnippet from './FeaturedSnippet';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';

function TabsPage({ markAIUsed }) {
  return (
    <Tabs defaultValue="custom">
      {/* Header and Tools Section - Gray Background */}
      <div className="bg-bg">
        <div className="max-w-5xl mx-auto px-6">
          <div className="mb-10 text-center pt-12">
            <h1 className="text-4xl font-bold tracking-tight text-text-primary mb-4">
              Character & Word Counter Tool Online
              <span className="text-xl block mt-3 text-text-secondary font-normal">
                (+ SEO Title, Meta Description and Featured Snippet Tools)
              </span>
            </h1>
          </div>

          <div className="flex flex-col items-center">
            <div className="mb-8 flex justify-center w-full">
              <TabsList>
                <TabsTrigger value="custom">
                  Custom Text 
                </TabsTrigger>
                <TabsTrigger value="titleMeta">
                  Title & Meta Description
                </TabsTrigger>
                <TabsTrigger value="featuredSnippet">
                  Featured Snippet
                </TabsTrigger>
              </TabsList>
            </div>
          </div>
        </div>

        {/* Tab Content - Still in Gray Background */}
        <div className="w-full">
          <TabsContent value="custom">
            <Custom markAIUsed={markAIUsed} />
          </TabsContent>
          <TabsContent value="titleMeta">
            <TitleMeta />
          </TabsContent>
          <TabsContent value="featuredSnippet">
            <FeaturedSnippet />
          </TabsContent>
        </div>
      </div>
    </Tabs>
  );
}

export default TabsPage; 